module.exports = __webpack_public_path__ + "img/LOGOZ.6a1ef4f5.png";